import { InputNumber } from "antd";
import useSettledNumber from "./useSettledNumber";

interface NumberInputProps
{
      value: number | null | undefined;
      min?: number;
      max?: number;
      step?: number;
      onChange: (val: number) => void;
      disabled?: boolean;
      placeholder?: string;
}

/**
 * The plain number field of the dynamic form.
 *
 * A bare AntD InputNumber with min/max refuses an out-of-range entry in silence:
 * `onChange` never fires, and leaving the box restores the previous value. On a
 * form that reads as "I changed the number, then it jumped back by itself" —
 * which is exactly how it was reported. This one states the allowed range up
 * front and, when a typed value is moved, says so.
 */
const NumberInput = ({
      value,
      min,
      max,
      step,
      onChange,
      disabled,
      placeholder,
}: NumberInputProps) =>
{
      const { draft, handleChange, handleBlur, clearAdjustment, hint, notice } =
            useSettledNumber({ value, min, max, step, onChange });

      return (
            <div className="w-full">
                  <InputNumber
                        className="w-full div-dropdown"
                        value={draft}
                        min={min}
                        max={max}
                        step={step}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onFocus={clearAdjustment}
                        disabled={disabled}
                        placeholder={placeholder}
                  />

                  {(notice || hint) && (
                        <p
                              className={`text-xs mt-1 mb-0 ${notice ? "text-yellow-400" : "text-gray-500"
                                    }`}
                              role={notice ? "status" : undefined}
                        >
                              {notice ?? hint}
                        </p>
                  )}
            </div>
      );
};

export default NumberInput;
